<style lang="less">
@import "detailsPrediction.less"; // 引入公共LESS文件
</style>
<template>
  <div>
    <div
      class="data-loading"
      style="padding: 20vh 0 50vh 0"
      v-if="logdingFlag()"
    >
      <van-loading vertical>{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</van-loading>
    </div>
    <div v-if="!loading && league && match && matchId" class="predictionWarp">
      <template v-if="Object.keys(masterM).length || Object.keys(pa).length">
        <div class="item-warp" v-if="Object.keys(masterM).length">
          <div class="item-head flex">
            <div class="title">{{ langConfig.details[langConfig.curLang]['PREDICTION']['MASTER_M'] }}</div>
            <div class="subtitle pc" v-if="masterM['confidence']">
              {{ masterM["side"] }}
              (
              <template v-for="(item, index) in masterM['confidence']"
                ><span :key="index" v-if="1">★</span></template
              >
              )
            </div>
          </div>
          <div class="item-body">
            <div class="subtitle mobile" v-if="masterM['confidence']">
              {{ masterM["side"] }}
              (
              <template v-for="(item, index) in masterM['confidence']"
                ><span :key="index" v-if="1">★</span></template
              >
              )
            </div>
            <div class="">
              <div v-if="!isLogin" class="unlogin-note">
                <div>{{ langConfig.details[langConfig.curLang]['PREDICTION']['AFTER_LOGIN'] }}</div>
                <div class="login-btn" @click="loginShow = true">{{ langConfig.details[langConfig.curLang]['PREDICTION']['LOG_IN'] }}</div>
              </div>
              <p class="content" v-else v-html="masterM['content']"></p>
            </div>
          </div>
        </div>
        <div class="item-warp" v-if="Object.keys(pa).length">
          <div class="item-head flex">
            <div class="title">{{ langConfig.details[langConfig.curLang]['PREDICTION']['FORTUNE_TELLER'] }}</div>
            <div class="subtitle pc" v-if="pa['score']">
              {{ langConfig.details[langConfig.curLang]['PREDICTION']['PREDICTED_SCORE'] }} {{ pa["score"] }}
            </div>
          </div>
          <div class="item-body">
            <div class="subtitle mobile" v-if="pa['score']">
              {{ langConfig.details[langConfig.curLang]['PREDICTION']['PREDICTED_SCORE'] }} {{ pa["score"] }}
            </div>
            <div class="">
              <div v-if="!isLogin" class="unlogin-note">
                <div>{{ langConfig.details[langConfig.curLang]['PREDICTION']['AFTER_LOGIN'] }}</div>
                <div class="login-btn" @click="loginShow = true">{{ langConfig.details[langConfig.curLang]['PREDICTION']['LOG_IN'] }}</div>
              </div>
              <p class="content" v-else v-html="pa['content']"></p>
            </div>
          </div>
        </div>
        <div class="remark" v-if="isLogin">
              {{ langConfig.details[langConfig.curLang]['PREDICTION']['NOTE'] }}
            </div>
      </template>
      <!-- 暂无数据 -->
      <DefaultPic v-else />
      <Login :loginShow="loginShow" @onChangePop="loginShow = false" />
    </div>
  </div>
</template>

<script>
import DefaultPic from "@/components/defaultPic";
import Login from "@/components/login.vue";
import { getMatchPrediction } from "@/api/api";
export default {
  components: {
    DefaultPic,
    Login,
  },
  data() {
    return {
      loginShow: false,
      isLogin: false,
      loading: true,
      baseParam: {
        userToken: "",
      },
      masterM: {},
      pa: {},
    };
  },
  methods: {
    // 用户信息
    userInfo() {
      let _userInfo = this.common.getCookie("userInfo");
      // console.log("userInfo", _userInfo);

      if (typeof _userInfo == "undefined" || _userInfo == null) {
        //console.log('no userinfo')
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
    logdingFlag() {
      if (typeof window != "undefined" && this.loading) {
        return true;
      }
      return false;
    },
    //数据读取
    async getMatchPredictionData() {
      let obj = {
        matchId: this.matchId,
      };
      var _this = this;
      let param = Object.assign(obj, this.baseParam);
      await getMatchPrediction(param)
        .then((res) => {
          this.loading = false;
          let data = JSON.parse(JSON.stringify(res.data));
          //console.log("getMatgetMatchPredictionDatachH2HData", data);
          if (data) {
            this.masterM = data.masterM || {};
            this.pa = data.pa || {};
          }
        })
        .catch((res) => {
          console.error(res);
        });
    },
    init() {
      if (!this.matchId) {
        return;
      }
      this.userInfo();
      this.getMatchPredictionData();
    },
  },
  created() {
    this.init();
  },
  watch: {
    matchId() {
      this.init();
    },
  },
  mounted() {},
  beforeDestroy() {},
  props: {
    //联赛信息
    league: {
      type: Object,
      default: null,
    },
    //比赛信息
    match: {
      type: Object,
      default: null,
    },
    //比赛ID
    matchId: {
      type: Number,
      default: null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsPrediction.vue